import { FC, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { of } from 'rxjs';
import { Tr } from '@utils';
import { useService } from '@hooks';
import { siteService, simulationService, ParkingAreaInfrastructure } from '@services';
import { Box, Stack } from '@mui/material';
import { PortalPageTitle } from '@components/portal/common';
import { LocationInfrastructureSizingKPIs, LocationInfrastructureSizingTable } from '@components/portal/locations';

const paddingX = 9;

export const LocationInfrastructureOverview: FC = () => {
	const navigate = useNavigate();
	const { siteId = '', simulationId = '' } = useParams<{ siteId: string; simulationId: string }>();
	const { data: site } = useService(() => (siteId ? siteService.get(siteId) : of()), [siteId]);
	const { data: parkingAreas } = useService(() => (siteId ? siteService.parkArea(siteId).getAll() : of()), [siteId]);
	const { data: simulation } = useService(() => (simulationId ? simulationService.get(simulationId) : of()), [simulationId]);
	const { data: kpi } = useService(() => (siteId ? simulationService.getKPIs(siteId) : of()), [siteId]);
	const [parkingAreaInfrastructures, setParkingAreaInfrastructures] = useState<ParkingAreaInfrastructure[]>([]);

	useEffect(() => {
		const infras =
			simulation?.infrastructure.siteInfrastructure.find(({ site: { id } }) => id === siteId)?.parkingAreaInfrastructure || [];

		setParkingAreaInfrastructures(
			infras
				.map((infra) => {
					infra.actualParkingArea = (parkingAreas || []).find(({ id }) => id === infra.parkingAreaId);
					return infra;
				})
				.sort((item1, item2) => item1.parkArea?.name.localeCompare(item2.parkArea?.name || ''))
		);
	}, [site, parkingAreas, simulation]);

	return (
		<Stack direction="column" spacing={4} sx={{ height: 1.0, maxHeight: 1.0, paddingY: 5, overflowY: 'auto' }}>
			<PortalPageTitle
				title={<Tr.Portal path="location.site-infra.title" options={{ name: site?.name || '' }} />}
				paddingX={3}
				onBackButtonClick={() => navigate(-1)}
			/>

			<Box sx={{ paddingX }}>
				<LocationInfrastructureSizingKPIs kpi={kpi} />
			</Box>

			<Box sx={{ flexGrow: 1, overflowY: 'auto', paddingLeft: paddingX }}>
				<LocationInfrastructureSizingTable sx={{ marginRight: paddingX }} parkingAreaInfrastructures={parkingAreaInfrastructures} />
			</Box>
		</Stack>
	);
};
